import React from 'react';
import { useLocation } from 'react-router-dom';
import Students from './Students';
import StudentView from './StudentView';
import StudentEdit from './StudentEdit';
import DashboardScreen from './DashboardScreen';

const StudentsRouteWrapper = ({ isEdit = false }) => {
  const location = useLocation();
  const studentData = location.state?.studentData;

  return (
    <DashboardScreen>
      {isEdit ? (
        <StudentEdit studentData={studentData} />
      ) : (studentData || location.pathname.split('/').pop() !== 'students' && location.pathname.split('/').pop() !== '') ? (
        <StudentView studentData={studentData} />
      ) : (
        <Students />
      )}
    </DashboardScreen>
  );
};

export default StudentsRouteWrapper;
